import * as React from "react";
import { memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDashboard = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 7,
			height: 9,
			x: 3,
			y: 3,
			rx: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 7,
			height: 5,
			x: 14,
			y: 3,
			rx: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 7,
			height: 9,
			x: 14,
			y: 12,
			rx: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 7,
			height: 5,
			x: 3,
			y: 16,
			rx: 1
		})
	]
});
const Memo = memo(SvgDashboard);
export default Memo;
